<template>
  <div class="wrap">
    <div class="leftBox">
      <img-box :imgSrc="dynamicImg.init" :activeImg="dynamicImg.initAct" title="初始化"></img-box>
      <div class="toRightImg">
        <img :src="dynamicImg.toRight" alt="" />
      </div>
      <img-box :imgSrc="dynamicImg.paramSet" :activeImg="dynamicImg.paramSetAct" title="参数设置"></img-box>
      <div class="toRightImg">
        <img :src="dynamicImg.toRight" alt="" />
      </div>
    </div>
    <div class="rightBox">
      <img-box
        class="box"
        :imgSrc="dynamicImg.customNo"
        :activeImg="dynamicImg.customNoAct"
        title="客户编码"
        @click.native="customShow()"
      ></img-box>
      <img-box
        class="box"
        :imgSrc="dynamicImg.goodsNo"
        :activeImg="dynamicImg.goodsNoAct"
        title="商品编码"
        @click.native="goodsShow()"
      ></img-box>
      <img-box
        class="box"
        :imgSrc="dynamicImg.buyCompany"
        :activeImg="dynamicImg.buyCompanyAct"
        title="购货单位"
      ></img-box>
      <img-box class="box" :imgSrc="dynamicImg.carNo" :activeImg="dynamicImg.carNoAct" title="车辆编码"></img-box>
      <img-box
        class="box"
        :imgSrc="dynamicImg.taxNo"
        :activeImg="dynamicImg.taxNoAct"
        title="税收编码"
        @click.native="taxShow()"
      ></img-box>
    </div>
    <custom-no ref="CustomNoForm"></custom-no>
    <goods-no ref="GoodsNoForm"></goods-no>
    <tax-no ref="TaxNoForm"></tax-no>
  </div>
</template>

<script>
import ImgBox from '@/components/ImgBox/Index.vue'
import popModal from '@/components/popModal/popModal.vue'
import CustomNo from './customNo.vue'
import GoodsNo from './goodsNo.vue'
import TaxNo from './taxNo'
import { dynamicImg } from '@/utils/dynamicImg'
export default {
  components: {
    ImgBox,
    popModal,
    CustomNo,
    GoodsNo,
    TaxNo,
  },
  data() {
    return {
      dynamicImg,
      isShowCustom: false,
    }
  },
  created() {},
  methods: {
    showChild(type) {
      switch (type) {
        case 'customNo':
          this.customShow()
          break
        case 'goodsNo':
          this.goodsShow()
          break
        case 'taxNo':
          this.taxShow()
          break
      }
    },
    customShow() {
      this.$refs.CustomNoForm.show()
    },
    goodsShow() {
      this.$refs.GoodsNoForm.show()
    },
    taxShow() {
      this.$refs.TaxNoForm.show()
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  width: 900px;
  height: 600px;
  display: block;
  position: relative;
  // border: 1px solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.leftBox {
  flex: 1;
  display: flex;
  justify-content: center;
  div {
    margin-right: 25px;
  }
  .toRightImg {
    line-height: 126px;
  }
}
.rightBox {
  flex: 1;
  // height: 100%;
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  flex-wrap: wrap;
  padding: 2%;
  .box {
    width: 50%;
    padding: 10px 0;
    display: inline-block;
    text-align: center;
    // display: flex;
    // align-items: center;
    // justify-content: center;
  }
}
.init-img {
  // background: url('~@/assets/init.png') no-repeat center;
}
</style>
